<template>
  <div v-if="show" class="fixed inset-0 z-50 overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
      <!-- 背景遮罩 -->
      <div
        v-if="show"
        class="fixed inset-0 transition-opacity"
        @click="closeModal"
      >
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <!-- 模态框内容 -->
      <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6">
        <!-- 标题 -->
        <div class="flex items-center justify-between mb-6">
          <div>
            <h3 class="text-lg font-medium text-gray-900">
              编辑子账户
            </h3>
            <p class="text-sm text-gray-500 mt-1 hidden sm:block">
              修改子账户的账号、密码及基本信息
            </p>
          </div>
          <button
            @click="closeModal"
            class="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
          >
            <XMarkIcon class="h-6 w-6" />
          </button>
        </div>

        <form @submit.prevent="handleSubmit">
          <div class="space-y-4 mb-6">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <!-- 邮箱 -->
              <div>
                <label for="edit-email" class="block text-sm font-medium text-gray-700 mb-2">
                  邮箱地址 <span class="text-red-500">*</span>
                </label>
                <input
                  id="edit-email"
                  v-model="form.email"
                  type="email"
                  required
                  class="w-full h-10 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200"
                  placeholder="user@example.com"
                />
                <p v-if="errors.email" class="mt-1 text-sm text-red-600">{{ errors.email }}</p>
              </div>

              <!-- 用户名 -->
              <div>
                <label for="edit-username" class="block text-sm font-medium text-gray-700 mb-2">
                  用户名 <span class="text-red-500">*</span>
                </label>
                <input
                  id="edit-username"
                  v-model="form.username"
                  type="text"
                  required
                  class="w-full h-10 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200"
                  placeholder="username"
                />
                <p v-if="errors.username" class="mt-1 text-sm text-red-600">{{ errors.username }}</p>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <!-- 新密码 -->
              <div>
                <label for="edit-password" class="block text-sm font-medium text-gray-700 mb-2">
                  新密码
                </label>
                <input
                  id="edit-password"
                  v-model="form.password"
                  type="password"
                  autocomplete="new-password"
                  class="w-full h-10 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200"
                  placeholder="留空则不修改"
                  minlength="8"
                />
                <p v-if="errors.password" class="mt-1 text-sm text-red-600">{{ errors.password }}</p>
                <p v-else class="mt-1 text-xs text-gray-400">如需修改密码请填写，至少 8 位字符；留空则保持原密码。</p>
              </div>

              <!-- 确认新密码 -->
              <div>
                <label for="edit-confirmPassword" class="block text-sm font-medium text-gray-700 mb-2">
                  确认新密码
                </label>
                <input
                  id="edit-confirmPassword"
                  v-model="form.confirmPassword"
                  type="password"
                  autocomplete="new-password"
                  class="w-full h-10 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200"
                  placeholder="重复输入新密码"
                />
                <p v-if="errors.confirmPassword" class="mt-1 text-sm text-red-600">{{ errors.confirmPassword }}</p>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <!-- 部门 -->
              <div>
                <label for="edit-department" class="block text-sm font-medium text-gray-700 mb-2">
                  部门
                </label>
                <input
                  id="edit-department"
                  v-model="form.department"
                  type="text"
                  class="w-full h-10 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200"
                  placeholder="如：销售部"
                />
              </div>

              <!-- 职位 -->
              <div>
                <label for="edit-position" class="block text-sm font-medium text-gray-700 mb-2">
                  职位
                </label>
                <input
                  id="edit-position"
                  v-model="form.position"
                  type="text"
                  class="w-full h-10 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200"
                  placeholder="如：销售经理"
                />
              </div>
            </div>

            <!-- 手机号 -->
            <div>
              <label for="edit-phone" class="block text-sm font-medium text-gray-700 mb-2">
                手机号
              </label>
              <input
                id="edit-phone"
                v-model="form.phone"
                type="tel"
                class="w-full h-10 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200"
                placeholder="如：13800138000"
              />
            </div>
          </div>

          <!-- 操作按钮 -->
          <div class="flex justify-end space-x-3 pt-6 border-t border-gray-200">
            <button
              @click="closeModal"
              type="button"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-colors"
              :disabled="submitting"
            >
              取消
            </button>

            <button
              @click="handleSubmit"
              type="button"
              :disabled="submitting"
              class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed flex items-center transition-colors"
            >
              <svg v-if="submitting" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {{ submitting ? '保存中...' : '保存修改' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, watch } from 'vue'
import { useToast } from 'vue-toastification'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { subAccountService } from '@/services/subAccountService'

const toast = useToast()

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  account: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['close', 'updated'])

// 表单数据
const form = reactive({
  email: '',
  username: '',
  password: '',
  confirmPassword: '',
  department: '',
  position: '',
  phone: ''
})

const submitting = ref(false)
const errors = ref({})

// 弹窗打开时用当前账户数据回填
watch(() => props.show, (show) => {
  if (show && props.account) {
    Object.assign(form, {
      email: props.account.email || '',
      username: props.account.username || '',
      password: '',
      confirmPassword: '',
      department: props.account.department || '',
      position: props.account.position || '',
      phone: props.account.phone || ''
    })
    errors.value = {}
    submitting.value = false
  }
})

const closeModal = () => {
  if (!submitting.value) {
    emit('close')
  }
}

// 表单校验
const validateForm = () => {
  errors.value = {}

  if (!form.email) {
    errors.value.email = '邮箱地址不能为空'
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
    errors.value.email = '请输入有效的邮箱地址'
  }

  if (!form.username) {
    errors.value.username = '用户名不能为空'
  } else if (form.username.length < 3) {
    errors.value.username = '用户名至少3个字符'
  }

  // 密码为可选，仅当填写时才校验
  if (form.password) {
    if (form.password.length < 8) {
      errors.value.password = '密码至少8个字符'
    }
    if (form.password !== form.confirmPassword) {
      errors.value.confirmPassword = '密码确认不匹配'
    }
  }

  return Object.keys(errors.value).length === 0
}

const handleSubmit = async () => {
  if (!props.account) return
  if (!validateForm()) {
    return
  }

  try {
    submitting.value = true

    const data = {
      email: form.email,
      username: form.username,
      department: form.department,
      position: form.position,
      phone: form.phone
    }

    // 仅当填写了新密码时才提交密码字段
    if (form.password) {
      data.password = form.password
      data.confirm_password = form.confirmPassword
    }

    await subAccountService.updateSubAccount(props.account.id, data)
    toast.success('子账户信息已更新')
    emit('updated')
  } catch (error) {
    console.error('更新子账户失败:', error)

    // 处理字段级验证错误
    const responseData = error.response?.data
    if (error.response?.status === 400 && responseData) {
      const fieldErrors = {}
      const errorMessages = []
      const fieldNameMap = {
        email: '邮箱',
        username: '用户名',
        password: '密码',
        confirm_password: '确认密码'
      }

      for (const [field, messages] of Object.entries(responseData)) {
        const message = Array.isArray(messages) ? (messages[0]?.string || messages[0]) : messages
        const localKey = field === 'confirm_password' ? 'confirmPassword' : field
        fieldErrors[localKey] = message
        errorMessages.push(`${fieldNameMap[field] || field}: ${message}`)
      }

      errors.value = fieldErrors
      if (errorMessages.length > 0) {
        toast.error(errorMessages.join('；'))
      }
      return
    }

    toast.error(error.message || '更新失败，请重试')
  } finally {
    submitting.value = false
  }
}
</script>
